
import { useCheckPermissions } from "@/shared";
import { SavePorcentajeIvaRet } from "../../shared/components/savePorcentajeRetIvaServicios";
import { PermissionsEnum } from "@/auth/interfaces";

export interface CreatePorcentajeIvaPageInterface {}

const CreatePorcentajeIvaPage: React.FC<CreatePorcentajeIvaPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_porcentajeretivaservicios);

  return <SavePorcentajeIvaRet titlePage="Crear Porcentaje IVA Retenido en Servicios" />;
};

export default CreatePorcentajeIvaPage;
